/* eslint-disable no-unused-vars */
import React from 'react';
import { Navigate } from 'react-router-dom';
import RL from './route-literals';
import { BreadcrumbItem, BreadcrumbItemTypes } from '../components/views/breadcrumbs';
import { TcpTypes } from '../slices/terms-conditions-policies';

const AppOutlet = React.lazy(() => import('../slices/app-outlet'));
const Landing = React.lazy(() => import('../slices/landing'));
const SignIn = React.lazy(() => import('../slices/sign-in'));
const SignUp = React.lazy(() => import('../slices/sign-up'));
const MainLayout = React.lazy(() => import('../slices/main-layout'));
const Dashboard = React.lazy(() => import('../slices/dashboard'));
const MyAccount = React.lazy(() => import('../slices/my-account'));
const MyAccountProfile = React.lazy(() => import('../slices/my-profile'));
const MyAccountSignatures = React.lazy(() => import('../slices/my-signatures'));
const Provisions = React.lazy(() => import('../slices/provisions'));
const Documents = React.lazy(() => import('../slices/documents'));
const Design = React.lazy(() => import('../slices/design'));
const TermsConditionsPolicies = React.lazy(() => import('../slices/terms-conditions-policies'));
const Demo = React.lazy(() => import('../slices/demo'));
const Verifier = React.lazy(() => import('../slices/verifier'));

const AppRoutes = [
  {
    element: <AppOutlet />,
    path: '/',
    breadcrumb: BreadcrumbItem.bind(null, { type: BreadcrumbItemTypes.HOME }),
    children: [
      {
        index: true,
        element: <Verifier />,
      },
      {
        element: <Verifier />,
        path: '/*',
      },
    ],
  },
];

export default AppRoutes;
